<script setup lang="ts">
withDefaults(defineProps<{ displaySmall?: boolean }>(), { displaySmall: false })
</script>

<template>
  <h1 class="flex justify-center text-2xl font-serpentine font-bold text-blue-900 cursor-default select-none">
    <span v-if="displaySmall">H</span>
    <span v-else>{{ $t('logo_text') }}</span>
    <span class="font-normal text-blue-400">OS</span>
  </h1>
</template>
